import {
  getSessionItem,
  setSessionItem,
  removeSessionItem,
} from 'js/storeManager'
import { wordpressApiHost } from 'js/config'

const getCache = endpoint => {
  try {
    return JSON.parse(getSessionItem(endpoint))
  } catch {
    return null
  }
}

const setCache = (endpoint, data) => {
  setSessionItem(endpoint, JSON.stringify(data))
  setSessionItem(endpoint + '-timestamp', Date.now())
}

const removeCache = endpoint => {
  removeSessionItem(endpoint)
  removeSessionItem(endpoint + '-timestamp')
}

const isCacheOld = endpoint => {
  const limit = 10 * 60000 // Minutes * Milliseconds
  const timestamp =
    Date.now() - parseInt(getSessionItem(endpoint + '-timestamp'), 10)

  if (isNaN(timestamp)) return true
  return timestamp > limit
}

export const getEndPoint = (endpoint, { cache = true } = {}) => {
  let headers = { 'Content-Type': 'application/json; charset=UTF-8' }

  if (cache) {
    const cacheData = getCache(endpoint)
    if (cacheData === null || isCacheOld(endpoint)) {
      removeCache(endpoint)
    } else {
      return Promise.resolve(cacheData)
    }
  }
  return fetch(wordpressApiHost + endpoint, {
    headers: headers,
  }).then(res => {
    const { ok } = res

    if (ok) {
      return res.json().then(data => {
        if (cache) setCache(endpoint, data)
        return data
      })
    }

    if (res.headers.get('content-type').match(/application\/json/)) {
      return res.json().then(error => {
        throw error
      })
    } else {
      return res.text().then(error => {
        throw new Error(
          `getEndPoint failed to fetch ${endpoint}. Raw response: ${error}`
        )
      })
    }
  })
}
